import styled from "styled-components";

export const MotivoRechazoContainer = styled.div`
  /* height: 228px; */
  height: max-content;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const MotivoRechazoBotones = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 10px;
  .btn-motivoRechazo{
    background-color: var(--color-primary);
    color: var(--color-white);
    width: 240px;
    padding: 10px 0;
    border-radius: 8px;
  }
  .btn-solicitarAtencion{
    background-color: var(--color-danger);
    color: var(--color-white);
    width: 240px;
    padding: 10px 0;
    border-radius: 8px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
